import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import logoPinguinoOffCanvas from "../imgOffCanvas/pinguinoOffCanvas.png";
import logoMinisoOffCanvas from "../imgOffCanvas/minisoLoveOffCanvas.webp";
import "../mioffCanvas.css";
import { IoIosArrowBack } from "react-icons/io";
//import {Tooltip} from 'react-bootstrap';
import MyTooltipOffCanvas from "./MyTooltipOffCanvas";
import { myId } from "../../../../lib/MyLibrary";

const GenericSubOffCanvas = ({
  showSubOffCanvas,
  handleCloseSubOffCanvas,
  subMenu,
}) => {
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  let auxTitle = "";
  if (subMenu[0].toLowerCase().includes("coca")) auxTitle = "Licencias";
  
  
  const handleOffCanvas= ()=>{
    setShowOffCanvas(prev=>!prev);
  }

  return (
    <div>
      <div onClick={handleOffCanvas}>
            {subMenu[0]}
      </div>
      <Offcanvas
        className="w-75"
        show={showSubOffCanvas||showOffCanvas}
        onHide={handleCloseSubOffCanvas||handleOffCanvas}
      >
        <Offcanvas.Header className="bg-light" closeButton>
          <Offcanvas.Title className="w-50 py-2">
            <div className="d-flex align-items-center justify-content-between w-100">
              <img
                style={{ width: "30px", height: "30px" }}
                src={logoPinguinoOffCanvas}
                alt="logoPinguinoOffCanvas"
              />
              <div className="ms-2 d-flex flex-column align-items-start justify-content-center myOffCanvasTitleHover">
                <p className="fs-6 smaller fw-light ms-1 mb-0">Únete a</p>
                <a href="https://www.miniso.com.mx/minisolove">
                  <img
                    style={{ width: "140px", height: "20px" }}
                    className="mt-0"
                    src={logoMinisoOffCanvas}
                    alt="logoMinisoOffCanvas"
                  />
                </a>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div onClick={handleCloseSubOffCanvas||handleOffCanvas} style={{cursor:'pointer'}} className="d-flex align-items-center">
            <IoIosArrowBack  className="fs-3 me-2"/>
            <h6 className="fs-3 text-danger opacity-75 fw-bold">{auxTitle !== "" ? `${auxTitle}` : `${subMenu[0]}`}</h6>
          </div>
          {subMenu.map((item, i,array) => {
            if (auxTitle === "" && i === 0) return "";
            else return <MyTooltipOffCanvas key={myId()} myTooltip={item} menu={array[0]}/>;
            
          })}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default GenericSubOffCanvas;
